export default __webpack_public_path__ + "static/contact-address-96734c587235ff77fd4c7d09a0f762aa.png";